"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadService = void 0;
var UploadService = /** @class */ (function () {
    function UploadService(api) {
        this._rtrTag = "RTR_";
        this._map = new Map();
        this.api = api;
    }
    UploadService.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.get("/upload/files?name_contains=".concat(this._rtrTag, "&_limit=-1"))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        this._map = new Map(data.map(function (c) { return [c.name.split(".")[0], c]; }));
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadService.prototype.getAvailableRTRImages = function () {
        return this._map;
    };
    UploadService.prototype.deleteOldFiles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(Array.from(this._map.values()).map(function (_a) {
                            var id = _a.id, name = _a.name;
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, this.api.delete("/upload/files/".concat(id))];
                                        case 1:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadService.prototype.deleteFile = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Somewhat we can have two images with same name, so be careful and delete every one
                    return [4 /*yield*/, Promise.all(Array.from(this._map.values())
                            .filter(function (c) { return c.name === name; })
                            .map(function (_a) {
                            var id = _a.id, name = _a.name;
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, this.api.delete("/upload/files/".concat(id))];
                                        case 1:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        }))];
                    case 1:
                        // Somewhat we can have two images with same name, so be careful and delete every one
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadService.prototype.uploadFile = function (path, file) {
        return __awaiter(this, void 0, void 0, function () {
            var form, existingImages, _i, existingImages_1, existingImage, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form = new FormData();
                        existingImages = Array.from(this._map.values())
                            .map(function (c) { return c.name; })
                            .filter(function (e) { return path.includes(e); });
                        _i = 0, existingImages_1 = existingImages;
                        _a.label = 1;
                    case 1:
                        if (!(_i < existingImages_1.length)) return [3 /*break*/, 4];
                        existingImage = existingImages_1[_i];
                        return [4 /*yield*/, this.deleteFile(existingImage)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        form.append("files", file, path);
                        return [4 /*yield*/, this.api.post("/upload", form)];
                    case 5:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data[0].id];
                }
            });
        });
    };
    UploadService.prototype.getImageId = function (foregroundImage) {
        var image = this._map.get(foregroundImage);
        if (!image) {
            console.log("Image ".concat(foregroundImage, " not found"));
            throw new Error();
        }
        return image.id;
    };
    return UploadService;
}());
exports.UploadService = UploadService;
